import { withLayout } from 'hoc';
import MainLayout from 'layout/MainLayout';

export const ClubLayout = withLayout(MainLayout);

export const AthletesLayout = withLayout(MainLayout);
